__webpack_require__.p = "/school/";